// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group.label-floating label.control-label, .form-group.label-placeholder label.control-label,
.form-group .checkbox label, .form-group .radio label, .form-group label {
  font-size: 14px;
}

label.control-label {
  font-size: 12px;
  line-height: 1.07142857;
  font-weight: 400;
  margin: 16px 0 0 0;
}

/** Buttons Dashboard - Calendar **/
.btn-group, .btn-group-vertical {
  width: 100%;
}

.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn:last-child:not(:first-child),
.btn-group>.dropdown-toggle:not(:first-child) {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}

input[type="checkbox"], input[type="radio"] {
  display:none;
  position: relative !important;
}

.btn.btn-raised {
  margin-right: 10px;
}

.btn.btn-raised:not(.btn-link):hover,
.btn:not(.btn-raised):not(.btn-link):hover {
  background-color: #0088cf;
  color: rgba(255,255,255, 0.7);
  max-width: 40%;
}

.btn.btn-raised:not(.btn-link).active,
.btn:not(.btn-raised):not(.btn-link).active {
  background-color: #0077B5;
  color: #fff;
  border-radius: 5px;
}

.btn:not(.btn-raised):not(.btn-link).not-editable:hover {
  background: none;
  cursor: default;
}

/* Small devices (tablets, 768px and up) */
@media (max-width: 768px) {
  select {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/Components/Overview/overview.component.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,WAAW;AACb;;AAEA;;;IAGI,2BAA2B;IAC3B,8BAA8B;IAC9B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".form-group.label-floating label.control-label, .form-group.label-placeholder label.control-label,\n.form-group .checkbox label, .form-group .radio label, .form-group label {\n  font-size: 14px;\n}\n\nlabel.control-label {\n  font-size: 12px;\n  line-height: 1.07142857;\n  font-weight: 400;\n  margin: 16px 0 0 0;\n}\n\n/** Buttons Dashboard - Calendar **/\n.btn-group, .btn-group-vertical {\n  width: 100%;\n}\n\n.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn:last-child:not(:first-child),\n.btn-group>.dropdown-toggle:not(:first-child) {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n}\n\ninput[type=\"checkbox\"], input[type=\"radio\"] {\n  display:none;\n  position: relative !important;\n}\n\n.btn.btn-raised {\n  margin-right: 10px;\n}\n\n.btn.btn-raised:not(.btn-link):hover,\n.btn:not(.btn-raised):not(.btn-link):hover {\n  background-color: #0088cf;\n  color: rgba(255,255,255, 0.7);\n  max-width: 40%;\n}\n\n.btn.btn-raised:not(.btn-link).active,\n.btn:not(.btn-raised):not(.btn-link).active {\n  background-color: #0077B5;\n  color: #fff;\n  border-radius: 5px;\n}\n\n.btn:not(.btn-raised):not(.btn-link).not-editable:hover {\n  background: none;\n  cursor: default;\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (max-width: 768px) {\n  select {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
